import { SearchUtils } from '@spotify/confidence-core-react';
import { ChatRefFragment } from '@spotify/confidence-graphql';

import { useChats } from '../useChats';

export const buildProjectChatsFilter = (projectName: string): string =>
  `project:${SearchUtils.escapeQuery(projectName)}`;

export const useActiveChats = (
  projectName: string,
): { chats: ChatRefFragment[]; isLoading: boolean } => {
  const { chats, isLoading } = useChats({
    filter: buildProjectChatsFilter(projectName),
    orderBy: 'updateTime:desc',
  });
  return {
    chats: chats ?? [],
    isLoading,
  };
};
